export default __webpack_public_path__ + "static/media/equatorial-guinea.17bc8896.png";